import { render, staticRenderFns } from "./FriendApply.vue?vue&type=template&id=0d2c4348&scoped=true"
import script from "./FriendApply.vue?vue&type=script&lang=js"
export * from "./FriendApply.vue?vue&type=script&lang=js"
import style0 from "./FriendApply.vue?vue&type=style&index=0&id=0d2c4348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c4348",
  null
  
)

export default component.exports